import NavBar from "./NavigationBar";
import { Suspense, useCallback, useEffect, useState } from "react";
import Header from "./Header";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import Loader from "../usercontrols/loader/loader";
import UserPortalAlert from "../alerts/UserPortalAlert";
import { getServicesThunk } from "../../reducers/thunks/services";
import CustomRoutes from "../../router/CustomRoutes";
import { IAuthenticationContext } from "../../auth/IAuthenticationContext";

const mystyle = {
  paddingTop: "51px",
  fontFamily: "Arial",
  height: "100vh",
  width: "100wh",
};

interface LayoutProps {
  authContext: IAuthenticationContext;
}

const Layout = (layoutProps: LayoutProps) => {
  const [hasServicesError, setHasServicesError] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const fetchServices = useCallback(async () => {
    try {
      await dispatch(getServicesThunk(layoutProps.authContext)).unwrap();
    } catch (e) {
      setHasServicesError(true);
      setTimeout(() => {
        setHasServicesError(false);
      }, 10000);
    }
  }, [dispatch, layoutProps.authContext]);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  if (layoutProps.authContext.isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div style={{ paddingLeft: 0 }} className="container-fluid">
        <Header />
        <div className="row mh-100" style={mystyle}>
          <div className="col-md-1 main-wrapper">
            <NavBar />
          </div>
          <div data-testid="routes" className="col-md-11 page-wrapper">
            <Suspense fallback={<div className="container">Loading...</div>}>
              <CustomRoutes />
            </Suspense>
          </div>
        </div>
      </div>

      {hasServicesError && (
        <UserPortalAlert
          varient="danger"
          text="Something went wrong. Unable to display the services you have access to."
          onCloseFn={() => setHasServicesError(false)}
        />
      )}
    </>
  );
};

export default Layout;
